/* eslint-disable @typescript-eslint/no-var-requires */
//query for ADF
export const phoenixShopADFSearchProductsByProperty = require('./phoenixShopSearchProductsByProperty.graphql');
export const phoenixShopADFConvertCurrencyQuery = require('./phoenixShopADFConvertCurrencyQuery.graphql');
export const phoenixADFShopSearchProductsByProperty = require('./phoenixShopADFSearchProductsByProperty.graphql');
